<template>
  <div class="container timeline-section">
    <div class="timeline-section-inner">
      <div class="timeline-section-img-wrap">
        <div class="timeline-section-grids">
          <div :ref="'section-imgs'" class="timeline-section-grid">
            <div
              v-for="i in 2"
              :key="i"
              class="timeline-section-img"
              :class="`images-${i}`"
              :style="style()"
            ></div>
          </div>
        </div>
      </div>
      <div class="timeline-section-content">
        <div>
          <h4>Timeline<br />1974-2024</h4>
          <div class="timeline-section-text">
            Celebrating 50 years of IEA history
          </div>
          <div class="timeline-button">
            <StyledButton primary @click="click">Explore Timeline</StyledButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { StyledButton } from "@international-energy-agency/vue-ui";
import gsap from "gsap";
export default {
  components: {
    StyledButton,
  },
  data() {
    return {
      url: "https://ieamaps.blob.core.windows.net/50th-anniversary/timeline-section/",
      imgs: 17,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const timeline = gsap.timeline({
        repeat: -1,
        repeatDelay: 1,
      });
      timeline.to(".timeline-section-grid", {
        yPercent: -100,
        duration: 0.4,
        ease: "power1.out",
        delay: "random(0, 2)",
        onComplete: (self) => this.replaceImage(self),
      });
      timeline.to(".timeline-section-grid", {
        yPercent: 0,
        data: "first-anim",
        duration: 0,
      });
    },
    style() {
      const { url, imgs } = this;
      const randomImage = Math.floor(Math.random() * imgs + 1);
      return `background-image: url(${url}50-anniv-ts-${randomImage}.png)`;
    },
    replaceImage() {
      const { url, imgs } = this;
      const img = this.$refs["section-imgs"];
      const randomImage = Math.floor(Math.random() * imgs + 1);
      let newImage = `url(${url}50-anniv-ts-${randomImage}.png)`;
      img.firstChild.style.backgroundImage = newImage;
      img.insertBefore(img.lastChild, img.firstChild);
    },
    click() {
      this.$emit("handle-timeline");
    },
  },
};
</script>

<style>
.timeline-section-img-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
}
.timeline-section-grids {
  width: 50%;
}
.timeline-section-grid {
  height: 100%;
}
.timeline-section-img {
  position: relative;
  width: 100%;
  height: 100%;
  background-position: 50% 50%;
  background-size: cover;
  filter: grayscale(100%);
  background-repeat: no-repeat;
}
.timeline-section-grids:after {
  content: "";
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.4;
  background: #000;
}
.timeline-section {
  position: relative;
}
.timeline-section-inner {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  transition: all 0.3s ease-out;
}
.lift {
  /* border: none; */
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  transition: all 0.3s ease-out;
}
.timeline-section-content {
  position: relative;
  display: flex;
  flex-flow: column;
  width: 50%;
  /* margin: 0 auto; */
  padding: 260px 0;
}
.timeline-section-content > div {
  /* width: 50%; */
  /* padding-right: 24px; */
  margin: 0 auto;
}
.timeline-button {
  margin-top: 18px;
}
.timeline-section-content h4 {
  font-size: 2.3125rem;
  line-height: 2.5rem;
  font-weight: 700;
  letter-spacing: -0.03em;
}
.timeline-section-text {
  font-size: 1.0625rem;
  line-height: 1.5rem;
  font-weight: 400;
  letter-spacing: 0;
  padding-top: 7px;
}
@media screen and (min-width: 1480px) {
  /* .timeline-section-inner {
    margin-left: calc((-100vw + 1384px) / 2);
  } */
}
@media screen and (min-width: 1280px) and (max-width: 1479px) {
  /* .timeline-section-inner {
    margin-left: calc(-48px);
  } */
}
@media screen and (min-width: 900px) and (max-width: 1279px) {
  .timeline-section-content {
    /* width: 680px; */
  }
}
@media screen and (min-width: 730px) and (max-width: 899px) {
  .timeline-section-content {
    /* width: 540px; */
  }
  .timeline-section-content h4 {
    font-size: 1.875rem;
    line-height: 2.125rem;
  }
}
@media screen and (min-width: 960px) and (max-width: 1279px) {
  /* .timeline-section-inner {
    margin-left: calc(-48px);
  } */
}
@media screen and (min-width: 730px) and (max-width: 959px) {
  /* .timeline-section-inner {
    margin-left: calc(-40px);
  } */
}
@media screen and (max-width: 729px) {
  .timeline-section-content {
    width: 100%;
    color: #fff;
    padding: 180px 0;
  }
  .timeline-section-content h4 {
    text-align: center;
  }
  .timeline-section-text {
    text-align: center;
  }
  .timeline-section-grids {
    width: 100%;
  }
  .timeline-section-content > div {
    padding-right: unset;
  }
  .timeline-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .timeline-section-grids:after {
    width: 100%;
  }
}
</style>
